<template>
  <!-- 编辑网点 -->
  <div class="page-container">
    <div class="page-top-tool">
      <el-page-header @back="goBack" content="编辑企业"></el-page-header>
    </div>
    <div class="form-layout">
      <el-form :model="form" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="企业编号" prop="name">
          {{form.info_no}}
        </el-form-item>
        <el-form-item label="企业名称" prop="name">
          <el-input v-model="form.name" size="mini" placeholder="请输入姓名" style="width: 300px;"></el-input>
        </el-form-item>
        <el-form-item label="Logo" prop="photo_pic">
          <el-upload
            class="avatar-uploader"
            accept="image/*"
            :action="uploadUrl"
            with-credentials
            :headers="headers"
            :show-file-list="false"
            :before-upload="beforeUploadPhotoPic"
            :on-success="handleLogoSuccess"
            :on-error="handleError">
            <img v-if="form.logo" :src="`${baseurl}/${form.logo}`" class="prview-pic">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="公司电话" prop="phone">
          <div>
            <div v-for="(item, index) in phoneList" :key="index">
              <el-input v-model="item.number" size="mini" placeholder="请输入" style="width: 300px;"></el-input>
              <el-button v-if="(index == phoneList.length - 1)" size="mini" plain style="margin-left: 10px;" @click="addPhoneItem" icon="el-icon-plus"></el-button>
              <el-button v-else-if="(index < phoneList.length - 1) && phoneList.length > 1" size="mini" plain style="margin-left: 10px;" @click="removePhoneItem(index)" icon="el-icon-minus" type="danger"></el-button>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="公司地址" prop="address">
          <el-input v-model="form.address" type="textarea" :rows="2" size="mini" placeholder="请输入公司地址" style="width: 300px;"></el-input>
        </el-form-item>
        <el-form-item label="纬度坐标(latitude)" prop="latitude">
          <el-input v-model="form.latitude" size="mini" placeholder="请输入地址纬度坐标" style="width: 300px;"></el-input>
          <span class="copy-link" v-clipboard:copy="form.address" v-clipboard:success="copyAddress" v-clipboard:error="onAddressCopyError">获取坐标</span>
        </el-form-item>
        <el-form-item label="经度坐标(longitude)" prop="longitude">
          <el-input v-model="form.longitude" size="mini" placeholder="请输入地址经度坐标" style="width: 300px;"></el-input>
        </el-form-item>
        <el-form-item label="多地址">
          <el-radio-group v-model="form.is_multiple_address" size="mini">
            <el-radio-button label="1">开启</el-radio-button>
            <el-radio-button label="-1">关闭</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="form.is_multiple_address == '1'" label="其他地址">
          <div>
            <div v-for="(item, index) in addressList" :key="index">
              <el-input v-model="item.title" size="mini" placeholder="输入标题" style="width: 200px;margin-right: 10px;"></el-input>
              <el-input v-model="item.address" size="mini" placeholder="输入地址" style="width: 300px;margin-right: 10px;"></el-input>
              <el-input v-model="item.latitude" size="mini" placeholder="纬度坐标(latitude)" style="width: 150px;margin-right: 10px;"></el-input>
              <el-input v-model="form.longitude" size="mini" placeholder="经度坐标(longitude)" style="width: 150px;margin-right: 10px;"></el-input>
              <el-button v-if="index == addressList.length - 1" size="mini" plain style="margin-left: 10px;" @click="pushAddressItem" icon="el-icon-plus"></el-button>
              <el-button v-else-if="(index < addressList.length - 1) && addressList.length > 1" size="mini" plain style="margin-left: 10px;" @click="removeAddressItem(index)" icon="el-icon-minus" type="danger"></el-button>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="企业视频" prop="video_url">
          <el-upload
            class="avatar-uploader"
            accept="video/*"
            :action="uploadUrl"
            with-credentials
            :headers="headers"
            :show-file-list="false"
            :before-upload="beforeUploadVideoPic"
            :on-success="handleVideoUrlSuccess"
            :on-error="handleError">
            <video v-if="form.video_url" :src="`${baseurl}/${form.video_url}`" class="prview-pic"></video>
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="视频封面" prop="video_image">
          <el-upload
            class="avatar-uploader"
            accept="image/*"
            :action="uploadUrl"
            with-credentials
            :headers="headers"
            :show-file-list="false"
            :before-upload="beforeUploadPhotoPic"
            :on-success="handleVideoImageSuccess"
            :on-error="handleError">
            <img v-if="form.video_image" :src="`${baseurl}/${form.video_image}`" class="prview-pic">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="名片海报" prop="poster_path">
          <el-upload
            class="avatar-uploader"
            accept="image/*"
            :action="uploadUrl"
            with-credentials
            :headers="headers"
            :show-file-list="false"
            :before-upload="beforeUploadPhotoPic"
            :on-success="handlePosterSuccess"
            :on-error="handleError">
            <img v-if="form.poster_path" :src="`${baseurl}/${form.poster_path}`" class="cardpic">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="企业简介" prop="desc_images">
          <el-upload
            class="avatar-uploader"
            accept="image/*"
            :action="uploadUrl"
            with-credentials
            :headers="headers"
            :show-file-list="false"
            :before-upload="beforeUploadPhotoPic"
            :on-success="handleCompanyDescPicSuccess"
            :on-error="handleError">
            <img v-if="form.desc_images" :src="`${baseurl}/${form.desc_images}`" class="desc_images">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="产品中心" prop="show_product">
          <el-radio-group v-model="form.show_product" size="mini">
            <el-radio-button label="1">展示</el-radio-button>
            <el-radio-button label="-1">隐藏</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="服务中心" prop="show_services">
          <el-radio-group v-model="form.show_services" size="mini">
            <el-radio-button label="1">展示</el-radio-button>
            <el-radio-button label="-1">隐藏</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-radio-group v-model="form.status" size="mini">
            <el-radio-button label="1">启用</el-radio-button>
            <el-radio-button label="2">停用</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="mini" @click="submitForm('ruleForm')">提 交</el-button>
          <el-button size="mini" @click="resetForm('ruleForm')">重 置</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UpdateStorePage',
  data() {
    return {
      form: {
        id: '',
        info_no: '',
        name: '',
        company_desc: '',
        product_desc: '',
        business_desc: '',
        history: '',
        team: '',
        salesman: '',
        show_state: '',
        poster_path: '',
        video_path: '',
        address: '',
        telephone: '',
        latitude: '',
        longitude: '',
        ebook_no: '',
        bookshelf_no: '',
        product_no: '',
        website_no: '',
        mall_no: '',
        ebook_url: '',
        is_multiple_address: '-1',
        is_multiple_language: '',
        is_multiple_company: '',
        multiple_json: '',
        show_ebook: '1',
        show_product: '-1',
        show_services: '-1',
        show_website: '-1',
        show_mall: '-1',
        show_video: '',
        video_url: '',
        video_image: '',
        show_company_desc: '',
        desc_format: '',
        desc_text: '',
        desc_images: '',
        logo: '',
        status: '1'
      },
      baseurl: '',
      uploadUrl: '',
      photoPicFile: null,
      photoPicPreviewUrl: '',
      headers: {
        'token': localStorage.getItem('weizhanToken')
      },
      phoneList: [
        { label: '', number: '' }
      ],
      addressList: [
        { title: '', address: '', latitude: '', longitude: '' }
      ]
    };
  },

  mounted() {
    this.baseurl = this.$baseUrl
    this.uploadUrl = this.$uploadUrl
    const info = sessionStorage.getItem('updateInformation')
    if (info) {
      this.form = JSON.parse(info)
      try {
        if (this.form.telephone) {
          this.phoneList = JSON.parse(this.form.telephone)
        }
      } catch(e) {
        this.$message.error('电话解析失败')
      }
      try {
        if (this.form.multiple_json) {
          this.addressList = JSON.parse(this.form.multiple_json)
        }
      } catch(e) {
        this.$message.error('多地址解析失败')
      }
      
    } else {
      this.$message.warning('参数有误，请重新选择要修改的网点')
      this.$router.push({
        path: '/information'
      })
    }
  },

  methods: {
    // 上传图片前的校验
    beforeUploadPhotoPic(file) {
      const isJPG = ['image/png','image/jpg','image/jpeg'].includes(file.type);
      const isLt2M = file.size / 1024 / 1024 < 2;
      
      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG/PNG 格式!');
        return false
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
        return false
      }
      return isJPG && isLt2M
    },
    // 上传视频前的校验
    beforeUploadVideoPic(file) {
      const isVideo = ['video/mp4', 'video/avi', 'video/mov', 'video/flv', 'video/wmv'].includes(file.type);

      if (!isVideo) {
        this.$message.error('请上传 mp4、avi、mov、flv、wmv 格式的视频');
        return false
      }
      
      // 可以同时验证文件大小（例如限制 50MB）
      const maxSize = 50 * 1024 * 1024; // 50MB
      if (file.size > maxSize) {
        this.$message.error('视频大小不能超过 50MB');
        return false
      }
      
      return true
    },
    // 上传企业Logo成功
    handleLogoSuccess(res, file) {
      this.form.logo = res.fileName
    },
    // 上传视频成功
    handleVideoUrlSuccess(res, file) {
      this.form.video_url = res.fileName
    },
    // 上传视频封面成功
    handleVideoImageSuccess(res, file) {
      this.form.video_image = res.fileName
    },
    // 上传海报成功
    handlePosterSuccess(res, file) {
      this.form.poster_path = res.fileName
    },
    // 上传企业简介
    handleCompanyDescPicSuccess(res, file) {
      this.form.desc_images = res.fileName
    },
    handleError(error, file, fileList) {
      this.$message.error('图片上传失败')
    },
    goBack() {
      this.$router.back()
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
    // 增加电话号
    addPhoneItem() {
      this.phoneList.push({ label: '', number: '' })
    },
    // 删除手机号
    removePhoneItem(index) {
      this.phoneList.splice(index, 1)
    },
    // 增加地址
    pushAddressItem() {
      this.addressList.push({ title: '', address: '', latitude: '', longitude: '' })
    },
    // 删除地址
    removeAddressItem(index) {
      this.addressList.splice(index, 1)
    },
    // 获取坐标信息
    copyAddress() {
      window.open('https://lbs.qq.com/getPoint/', '_blank')
    },
    // 地址复制失败
    onAddressCopyError() {
      this.$message.warning('请先输入地址')
    },
    getCurrentTime() {
      const now = new Date();
  
      // 获取年、月、日、时、分、秒
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');
      const hours = String(now.getHours()).padStart(2, '0');
      const minutes = String(now.getMinutes()).padStart(2, '0');
      const seconds = String(now.getSeconds()).padStart(2, '0');
      
      // 拼接成指定格式
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
            this.form.telephone = JSON.stringify(this.phoneList)
            if (this.form.is_multiple_address == '1') {
              this.form.multiple_json = JSON.stringify(this.addressList)
            }
            this.$http({
              method: 'post',
              url: '/information/update',
              params: {
                ...this.form,
                update_time: this.getCurrentTime()
              }
            })
            .then(res => {
              if (res.errno == 0) {
                this.$message.success('修改成功')
                this.resetForm('ruleForm')
                this.phoneList = [ { label: '', number: '' } ],
                this.addressList = [ { title: '', address: '', latitude: '', longitude: '' } ]
                this.goBack()
              } else {
                this.$message.error('修改失败')
              }
            })
            .catch(err => {
              this.$message.error('修改失败，服务端异常')
              console.error('操作异常：', err.message);
            })
        } else {
          return false;
        }
      })
    },
  },
};
</script>

<style lang="scss" scoped>
.page-container {
  background: #fff;
  height: 100%;
  width: 100%;
  border-radius: 3px;
  box-sizing: border-box;
  padding: 20px 25px;
  overflow-y: scroll;

  .page-top-tool {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 12px;
  }

  .form-layout {
    margin: 30px 0px;
    padding: 10px 30px;
  }
}

/* 修改滚动条样式 */
.page-container::-webkit-scrollbar {
	width: 4px;
}
.page-container::-webkit-scrollbar-thumb {
	border-radius: 10px;
	-webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
	background: rgba(0, 0, 0, 0.2);
}

.avatar-uploader {
  cursor: pointer;
  position: relative;
  width: 120px;
  height: 120px;
}
.avatar-uploader-icon:hover {
  border-color: #409EFF;
  color: #409EFF;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 120px;
    height: 120px;
    line-height: 120px;
    text-align: center;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
}
.prview-pic {
    width: 120px;
    height: 120px;
    display: block;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
}
.cardpic {
    width: 200px;
    height: 100px;
    display: block;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
}
.desc_images {
  height: 100px;
  border: 1px solid red;
  display: block;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  overflow: hidden;
}
.copy-link {
  margin-left: 10px;
  color: #409EFF;
}
.copy-link:hover {
  cursor: pointer;
}
</style>